import { useCallback, useEffect, useState } from "react";
import {
  deleteMeal,
  getUneatenMeals,
  markMealAsEaten,
  Meal,
} from "./airtable/Airtable";
import DatePicker from "react-datepicker";
import {
  Button,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "semantic-ui-react";

import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

export function UneatenMeals() {
  const [meals, setMeals] = useState<Meal[] | undefined>(undefined);

  const onResetMeals = useCallback(() => {
    getUneatenMeals().then((meals) => {
      setMeals(meals);
    });
  }, []);

  useEffect(() => {
    onResetMeals();
  }, [onResetMeals]);

  if (meals === undefined) {
    return null;
  }

  return (
    <div style={{ marginTop: "8px" }}>
      <Table celled padded>
        <TableBody>
          {meals.length === 0 && (
            <TableRow>
              <TableCell>
                No Meals! <Link to={"/add"}>Go Add One</Link>
              </TableCell>
            </TableRow>
          )}
          {meals.map((meal, index) => {
            return (
              <TableRow key={meal.id}>
                <TableCell>{meal.name}</TableCell>
                <TableCell>
                  <EatAMeal mealId={meal.id} onResetMeals={onResetMeals} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

interface EatAMealProps {
  mealId: string;
  onResetMeals: () => void;
}

function EatAMeal({ mealId, onResetMeals }: EatAMealProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dateYouAte, setDateYouAte] = useState<Date | null>(null);
  const [isHoverDelete, setIsHoverDelete] = useState<boolean>(false);

  const onEaten = useCallback(async () => {
    setIsLoading(true);
    await markMealAsEaten(mealId, dateYouAte ?? new Date());
    onResetMeals();
  }, [mealId, dateYouAte, onResetMeals]);

  const onDelete = useCallback(async () => {
    setIsLoading(true);
    await deleteMeal(mealId);
    onResetMeals();
  }, [mealId, onResetMeals]);

  return (
    <div style={{ display: "flex" }}>
      <div>
        <Button primary loading={isLoading} onClick={onEaten}>
          EAT IT!
        </Button>
      </div>
      <div>
        <DatePicker
          showIcon
          toggleCalendarOnIconClick
          placeholderText="Pick If Not Today"
          className="date-picker"
          selected={dateYouAte}
          onChange={(date) => {
            if (date) {
              setDateYouAte(date);
            }
          }}
        />
      </div>
      <div style={{ alignContent: "center" }}>
        <Icon
          circular
          size="tiny"
          color={isHoverDelete ? "red" : "black"}
          style={{
            marginLeft: "5px",
            cursor: "pointer",
          }}
          name="trash alternate"
          onMouseOver={() => setIsHoverDelete(true)}
          onMouseOut={() => setIsHoverDelete(false)}
          onClick={onDelete}
        />
      </div>
    </div>
  );
}
